(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-topic', {
            parent: 'entity',
            url: '/communication-topic?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.communicationTopic.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic/communication-topics.html',
                    controller: 'CommunicationTopicController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-topic-detail', {
            parent: 'entity',
            url: '/communication-topic/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.communicationTopic.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic/communication-topic-detail.html',
                    controller: 'CommunicationTopicDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationTopic', function($stateParams, CommunicationTopic) {
                    return CommunicationTopic.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-topic.new', {
            parent: 'communication-topic',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic/communication-topic-dialog.html',
                    controller: 'CommunicationTopicDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-topic', null, { reload: true });
                }, function() {
                    $state.go('communication-topic');
                });
            }]
        })
        .state('communication-topic.edit', {
            parent: 'communication-topic',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic/communication-topic-dialog.html',
                    controller: 'CommunicationTopicDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationTopic', function(CommunicationTopic) {
                            return CommunicationTopic.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-topic.delete', {
            parent: 'communication-topic',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic/communication-topic-delete-dialog.html',
                    controller: 'CommunicationTopicDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationTopic', function(CommunicationTopic) {
                            return CommunicationTopic.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
